import 'lazysizes';
import 'lazysizes/plugins/aspectratio/ls.aspectratio.js';
// Опционально: можно импортировать плагины для lazysizes, если нужны (например, для background-image)
// import 'lazysizes/plugins/bgset/ls.bgset.js';

import * as mainStyles from '../styles/main.css'; 
import * as galleryStyles from '../styles/gallery.css'; // Still useful if gallery.css has its own local styles

// Lazysizes debug events
document.addEventListener('lazyloaded', function(e){
    const imageElement = e.target;
    const parentBentoItem = imageElement.closest('.bento-item'); // .bento-item is global
    if (parentBentoItem) {
        const skeletonElement = parentBentoItem.querySelector('.skeleton'); // .skeleton is global
        if (skeletonElement) {
            skeletonElement.style.display = 'none';
        }
    }
});

const asciiArt = `
           __        __
  _______ / /  __ __/ /    ___ ___  ___ ________
 / __/ -_) _ \\/ // / _ \\_ (_-</ _ \\/ _ \`/ __/ -_)
/_/  \\__/_//_/\\_,_/_.__(_)___/ .__/\\_,_/\\__/\\__/
                            /_/
`;

const colors = [
    '#FFF',
    '#000',
];
let colorIndex = 0;
let animationInterval;
// let asciiArtContainer = null; // Removed, was for <pre>

// Constants for canvas text rendering
const fontSize = 8; // px
const fontFamily = 'monospace';
const lineHeight = fontSize; // User reverted to this for main ASCII art

const subtitleText = "private gaming community";
const subtitleFontSize = 16; // Changed to 16 as requested
const subtitleLineHeight = subtitleFontSize + 4; // Adjusted to 16 + 4 = 20

// Canvas related vars
let canvas = null;
let ctx = null;

function animateAsciiArt() {
    // --- Console Animation Part (as requested by user) ---
    console.clear();
    if (colorIndex === 0) console.log(`%c${asciiArt}`, `color: ${colors[colorIndex]}`);

    // --- HTML Canvas Animation Part ---
    if (canvas && ctx) {
        const lines = asciiArt.split('\n');
        const currentAsciiColor = colors[colorIndex]; // Color for the ASCII art

        ctx.fillStyle = '#000000'; // User set hardcoded background
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // --- Draw ASCII Art ---
        ctx.font = `${fontSize}px ${fontFamily}`;
        ctx.fillStyle = currentAsciiColor; // Use blinking color for ASCII art
        lines.forEach((line, i) => {
            ctx.fillText(line, 0, i * lineHeight);
        });

        // --- Draw Subtitle ---
        const subtitleY = (lines.length * lineHeight) + lineHeight; 
        
        ctx.font = `${subtitleFontSize}px ${fontFamily}`;
        ctx.fillStyle = '#FFFFFF'; // Static white color for the subtitle
        const subtitleWidth = ctx.measureText(subtitleText).width;
        const subtitleX = (canvas.width - subtitleWidth) / 2;
        ctx.fillText(subtitleText, subtitleX, subtitleY);
    }

    colorIndex = (colorIndex + 1) % colors.length; // Still need to cycle for ASCII art color
}

// Page Preloader Logic
window.addEventListener('load', function () {
    const preloader = document.getElementById('page-preloader');
    if (preloader) {
        setTimeout(() => {
            preloader.classList.add(mainStyles.loaded); // Obfuscated
        }, 500); 
    }
});

document.addEventListener('DOMContentLoaded', () => {
    // asciiArtContainer = document.getElementById('ascii-art-container'); // Removed

    canvas = document.getElementById('ascii-art-canvas');

    if (canvas) {
        ctx = canvas.getContext('2d');
        const asciiLines = asciiArt.split('\n'); // Renamed for clarity
        const longestAsciiLineLength = asciiLines.reduce((max, lineStr) => Math.max(max, lineStr.length), 0);

        // Calculate width based on ASCII art font
        ctx.font = `${fontSize}px ${fontFamily}`;
        const charWidth = ctx.measureText('M').width;
        canvas.width = longestAsciiLineLength * charWidth;

        // Calculate height: ASCII lines + one empty line (using main lineHeight) + subtitle line (using subtitleLineHeight)
        canvas.height = (asciiLines.length * lineHeight) + lineHeight + subtitleLineHeight;

        // Set textBaseline once after canvas dimensions are set
        ctx.textBaseline = 'top';
        // Initial font for ASCII art (will be switched in animateAsciiArt as needed)
        ctx.font = `${fontSize}px ${fontFamily}`;

        if (animationInterval) clearInterval(animationInterval);
        animationInterval = setInterval(animateAsciiArt, 200);
    }

    const seasonsContainer = document.getElementById('seasons-container');

    // Wrap season descriptions for new animation method
    const seasonEntries = seasonsContainer ? seasonsContainer.querySelectorAll('.season-entry') : []; // Global
    seasonEntries.forEach(entry => {
        const description = entry.querySelector('.season-description'); // Global
        if (description) {
            const wrapper = document.createElement('div');
            wrapper.classList.add(mainStyles.contentWrapper); // Obfuscated class for the wrapper
            
            // entry.replaceChild(wrapper, description); // Incorrect way to move
            // wrapper.appendChild(description); // Then append description to wrapper
            
            // Correctly move description into wrapper, and wrapper into entry's correct spot
            description.parentNode.insertBefore(wrapper, description); // Insert wrapper before description
            wrapper.appendChild(description); // Move description into wrapper
        }
    });

    function setAccordionMaxHeight(entryElement, isOpen) {
        const wrapper = entryElement.querySelector(`.${mainStyles.contentWrapper}`);
        const description = wrapper ? wrapper.querySelector('.season-description') : null;
        if (wrapper && description) {
            if (isOpen) {
                // Temporarily set to auto or scrollHeight to measure, then apply for transition
                // For opening, we need the scrollHeight of the description itself.
                wrapper.style.maxHeight = description.scrollHeight + 'px';
            } else {
                wrapper.style.maxHeight = '0px';
            }
        }
    }

    if (seasonsContainer) {
        seasonsContainer.addEventListener('click', (event) => {
            const title = event.target.closest('.season-title'); // Global
            if (title) {
                const entry = title.closest('.season-entry'); // Global
                if (entry) {
                    const isActive = entry.classList.contains(mainStyles.active);
                    // Toggle active class first to trigger opacity transition
                    entry.classList.toggle(mainStyles.active);
                    // Then set max-height for the animation
                    setAccordionMaxHeight(entry, !isActive); // If it WASN'T active, it IS NOW being opened
                }
            }
        });
    }

    // Bento Gallery Modal Logic
    const seasonsContainerForModal = document.getElementById('seasons-container');
    let modal = null;
    let currentModalImageSources = [];
    let currentModalIndex = 0;

    function showModal(imgSrc, index, imageArray) {
        if (modal) modal.remove();
        currentModalImageSources = imageArray; 
        currentModalIndex = index;

        modal = document.createElement('div');
        modal.classList.add(mainStyles.modalOverlay); // Obfuscated
        modal.innerHTML = `
            <div class="${mainStyles.modalContent}">
                <span class="${mainStyles.modalArrow} ${mainStyles.modalPrev}">&lt;</span>
                <img src="${imgSrc}" alt="Fullscreen screenshot">
                <span class="${mainStyles.modalArrow} ${mainStyles.modalNext}">&gt;</span>
                <span class="${mainStyles.modalClose}">&times;</span>
            </div>
        `;
        document.body.appendChild(modal);

        // Trigger transition for modal appearance
        requestAnimationFrame(() => {
            modal.classList.add(mainStyles.modalVisible); // Obfuscated class for visible state
        });

        modal.querySelector(`.${mainStyles.modalClose}`).addEventListener('click', closeModal); // Query with obfuscated
        modal.querySelector(`.${mainStyles.modalPrev}`).addEventListener('click', () => showPrevModalImage()); // Query with obfuscated
        modal.querySelector(`.${mainStyles.modalNext}`).addEventListener('click', () => showNextModalImage()); // Query with obfuscated
        
        modal.addEventListener('click', (e) => {
            if (e.target === modal) closeModal();
        });
        document.addEventListener('keydown', handleModalKeys);
        updateModalImage(); 
    }

    function updateModalImage() {
        if (modal && currentModalImageSources[currentModalIndex]) {
            const modalImg = modal.querySelector(`.${mainStyles.modalContent} img`); // Query with obfuscated
            modalImg.src = currentModalImageSources[currentModalIndex];
            modalImg.alt = `Fullscreen screenshot ${currentModalIndex + 1}`;
        }
    }

    function showPrevModalImage() {
        currentModalIndex = (currentModalIndex > 0) ? currentModalIndex - 1 : currentModalImageSources.length - 1;
        updateModalImage();
    }

    function showNextModalImage() {
        currentModalIndex = (currentModalIndex < currentModalImageSources.length - 1) ? currentModalIndex + 1 : 0;
        updateModalImage();
    }

    function closeModal() {
        if (modal) {
            // Remove visible class to trigger fade-out, then remove from DOM after transition
            modal.classList.remove(mainStyles.modalVisible);
            // Listen for transition end on the overlay
            modal.addEventListener('transitionend', function handleTransitionEnd(event) {
                // Make sure it's the opacity transition on the overlay itself
                if (event.target === modal && event.propertyName === 'opacity') {
                    modal.removeEventListener('transitionend', handleTransitionEnd);
                    if (modal.parentNode) { // Check if still in DOM
                        modal.remove();
                    }
                    modal = null; // Clear modal variable after fully removed
                }
            });
            // Fallback if transitionend doesn't fire (e.g. display:none interrupts it)
            // or if an element has no transition applied for some reason.
            // The timeout should be a bit longer than the CSS transition duration.
            setTimeout(() => {
                if (modal && modal.parentNode) {
                    modal.remove();
                    modal = null;
                }
            }, 300); // Corresponds to 0.25s transition + buffer

            document.removeEventListener('keydown', handleModalKeys);
        }
    }

    function handleModalKeys(e) {
        if (!modal) return;
        if (e.key === 'Escape') closeModal();
        if (e.key === 'ArrowLeft') showPrevModalImage();
        if (e.key === 'ArrowRight') showNextModalImage();
    }

    if (seasonsContainerForModal) {
        seasonsContainerForModal.addEventListener('click', (event) => {
            const clickedImage = event.target.closest('.bento-item img.modal-trigger'); // Global classes
            if (clickedImage) {
                const gallery = clickedImage.closest('.bento-gallery'); // Global class
                if (gallery) {
                    const allGalleryImages = Array.from(gallery.querySelectorAll('.bento-item img.modal-trigger')); // Global classes
                    const imageSources = allGalleryImages.map(img => img.src);
                    const clickedImageIndex = allGalleryImages.findIndex(img => img === clickedImage);
                    
                    if (clickedImageIndex !== -1) {
                        showModal(clickedImage.src, clickedImageIndex, imageSources);
                    }
                }
            }
        });
    }

    const preloaderDOM = document.getElementById('preloader'); // Renamed to avoid conflict with outer scope preloader
    if (preloaderDOM) {
        window.addEventListener('load', () => {
            preloaderDOM.style.opacity = '0';
            setTimeout(() => {
                preloaderDOM.style.display = 'none';
            }, 500); 
        });
    }

    document.addEventListener('lazyloaded', function(e) {
        const img = e.target;
        const item = img.closest('.bento-item'); // Global
        if (item) {
            const skeleton = item.querySelector('.skeleton'); // Global
            if (skeleton) {
                skeleton.style.display = 'none';
            }
        }
        layoutAllGalleries(); 

        // Update accordion max-height if a lazyloaded image is inside an open accordion
        const activeAccordionEntry = img.closest(`.${mainStyles.active}`); // Check if inside an active entry
        if (activeAccordionEntry) {
            setAccordionMaxHeight(activeAccordionEntry, true); // true because it's already open
        }
    });

    function layoutGallery(galleryElement, targetRowHeight = 180, gap = 5) {
        const items = Array.from(galleryElement.querySelectorAll('.bento-item')); // Global
        if (!items.length) return;

        galleryElement.style.display = 'flex';
        galleryElement.style.flexWrap = 'wrap';
        galleryElement.style.gap = `${gap}px`;

        items.forEach(item => {
            const img = item.querySelector('img');
            if (!img) return;

            const originalWidth = parseInt(img.getAttribute('width'), 10);
            const originalHeight = parseInt(img.getAttribute('height'), 10);
            if (isNaN(originalWidth) || isNaN(originalHeight) || originalHeight === 0) return;

            const newWidth = (originalWidth * targetRowHeight) / originalHeight;
            
            item.style.width = `${newWidth}px`;
            item.style.height = `${targetRowHeight}px`;
            const wrapper = item.querySelector('.image-aspect-ratio-wrapper'); // Global
            if(wrapper) {
                wrapper.style.paddingBottom = '0'; 
                wrapper.style.height = '100%';
            }
        });
    }

    function layoutAllGalleries() {
        const galleries = document.querySelectorAll('.bento-gallery'); // Global
        galleries.forEach(gallery => {
            layoutGallery(gallery, 180, 5); 
        });
    }

    layoutAllGalleries();

    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            layoutAllGalleries();
            // Update max-height for all open accordions on resize
            const openAccordions = document.querySelectorAll(`.${mainStyles.active}`);
            openAccordions.forEach(acc => {
                if(acc.matches('.season-entry')) { // Ensure it's a season entry
                    setAccordionMaxHeight(acc, true);
                }
            });
        }, 250);
    });
});